import { CostEstimateOption, EducationGoalData, TuitionType } from './Education.meta';
import { ALREADY_ENROLLED } from '../../Goals.meta';

interface Params {
  goalData: EducationGoalData;
}

export const useEducation = ({ goalData }: Params) => {
  return {
    ...goalData,
    ageOptions: [
      { label: ALREADY_ENROLLED, value: ALREADY_ENROLLED },
      ...goalData.ageOptions.map(age => ({
        label: age.toString(),
        value: age,
      })),
    ],
    costEstimateOptions: [
      { label: 'National Average', value: CostEstimateOption.NationalAverage },
      { label: 'Specific College', value: CostEstimateOption.SpecificCollege },
    ],
    tuitionTypeOptions: [
      { label: 'Out-of-state', value: TuitionType.OutOfState },
      { label: 'In-state', value: TuitionType.InState },
    ],
  };
};
